// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .search-bar {
  position: relative;
  width: 400px;
  margin: 0;
  display: inline-block;
}

.search-bar input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  font-family: Poppins;
  margin-left: 14px;
}

.search-bar input:focus {
  outline: none;
}

.search-bar input::placeholder {
  color: #979797;
}

.suggestions-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 150px;
  overflow-y: auto;
  background-color: white;
  position: absolute;
  width: calc(100% - 14px);
  z-index: 1000;
}

.suggestions-list li {
  padding: 10px;
  cursor: pointer;
}

.suggestions-list li:hover {
  background-color: #f0f0f0;
} */
.search-bar {
  position: relative;
  width: 400px;
  margin: 0;
  display: inline-block;
}

.search-bar input {
  width: 100%;
  padding: 10px;
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  margin-left: 14px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
}

.search-bar input:focus {
  outline: none;
  border-color: #a1a1a1;
  background-color: #ffffff;
}

.search-bar input::placeholder {
  color: #b0b0b0;
}

.suggestions-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #d1d1d1;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 150px;
  overflow-y: auto;
  background-color: #ffffff;
  position: absolute;
  width: calc(100% - 14px);
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.suggestions-list li {
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
}

.suggestions-list li:hover {
  background-color: #e9e9e9;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SearchBar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8CG;AACH;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* .search-bar {\n  position: relative;\n  width: 400px;\n  margin: 0;\n  display: inline-block;\n}\n\n.search-bar input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: Poppins;\n  margin-left: 14px;\n}\n\n.search-bar input:focus {\n  outline: none;\n}\n\n.search-bar input::placeholder {\n  color: #979797;\n}\n\n.suggestions-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #ccc;\n  border-top: none;\n  max-height: 150px;\n  overflow-y: auto;\n  background-color: white;\n  position: absolute;\n  width: calc(100% - 14px);\n  z-index: 1000;\n}\n\n.suggestions-list li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.suggestions-list li:hover {\n  background-color: #f0f0f0;\n} */\n.search-bar {\n  position: relative;\n  width: 400px;\n  margin: 0;\n  display: inline-block;\n}\n\n.search-bar input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #d1d1d1;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n  margin-left: 14px;\n  background-color: #f9f9f9;\n  transition: all 0.3s ease;\n}\n\n.search-bar input:focus {\n  outline: none;\n  border-color: #a1a1a1;\n  background-color: #ffffff;\n}\n\n.search-bar input::placeholder {\n  color: #b0b0b0;\n}\n\n.suggestions-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #d1d1d1;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  max-height: 150px;\n  overflow-y: auto;\n  background-color: #ffffff;\n  position: absolute;\n  width: calc(100% - 14px);\n  z-index: 1000;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.suggestions-list li {\n  padding: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.suggestions-list li:hover {\n  background-color: #e9e9e9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
